// extracted by mini-css-extract-plugin
export default {"PreferencesCard":"PreferencesCard_PreferencesCard__-H+1Q"};